const state = {
  isAuthenticated: false,
  callbackUrl: '',
  callbackPrefix: '',
  ticket: '',
  twebmail: '',
  tprarams: '',
  routePath: {},
  accessTokenWebmail: '',
  isCheckingStatus: false,
  googleAccountInfo: {},
};

const getters = {
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  callbackUrl(state) {
    return state.callbackUrl;
  },
  callbackPrefix(state) {
    return state.callbackPrefix;
  },
  ticket(state) {
    return state.ticket;
  },
  twebmail(state) {
    return state.twebmail;
  },
  tprarams(state) {
    return state.tprarams;
  },
  routePath(state) {
    return state.routePath;
  },
  accessTokenWebmail(state) {
    return state.accessTokenWebmail;
  },
  isCheckingStatus(state) {
    return state.isCheckingStatus;
  },
  googleAccountInfo(state) {
    return state.googleAccountInfo;
  },
};

const mutations = {
  UPDATE_AUTHENTICATED(state, payload) {
    state.isAuthenticated = payload;
  },
  UPDATE_CALLBACK_URL(state, payload) {
    state.callbackUrl = payload;
  },
  UPDATE_CALLBACK_PREFIX(state, payload) {
    state.callbackPrefix = payload;
  },
  UPDATE_TICKET(state, payload) {
    state.ticket = payload;
  },
  UPDATE_TWEBMAIL(state, payload) {
    state.twebmail = payload;
  },
  UPDATE_T_PARAMS(state, payload) {
    state.tprarams = payload;
  },
  UPDATE_ROUTE_PATH(state, payload) {
    state.routePath = payload;
  },
  UPDATE_ACCESS_TOKEN_WEBMAIL(state, payload) {
    state.accessTokenWebmail = payload;
  },
  UPDATE_CHECKING_STATUS(state, payload) {
    state.isCheckingStatus = payload;
  },
  UPDATE_GOOGLE_ACCOUNT_INFO(state, payload) {
    state.googleAccountInfo = payload;
  },
};

const actions = {
  updateAuthenticated({ commit }, payload) {
    commit('UPDATE_AUTHENTICATED', payload);
  },
  updateCallbackUrl({ commit }, payload) {
    commit('UPDATE_CALLBACK_URL', payload);
  },
  updateCallbacPrefix({ commit }, payload) {
    commit('UPDATE_CALLBACK_PREFIX', payload);
  },
  updateTicket({ commit }, payload) {
    commit('UPDATE_TICKET', payload);
  },
  updateTwebmail({ commit }, payload) {
    commit('UPDATE_TWEBMAIL', payload);
  },
  updateTParam({ commit }, payload) {
    commit('UPDATE_T_PARAMS', payload);
  },
  updateRoutePath({ commit }, payload) {
    commit('UPDATE_ROUTE_PATH', payload);
  },
  updateAccessTokenWebmail({ commit }, payload) {
    commit('UPDATE_ACCESS_TOKEN_WEBMAIL', payload);
  },
  updateCheckingStatus({ commit }, payload) {
    commit('UPDATE_CHECKING_STATUS', payload);
  },
  updateGoogleAccountInfo({ commit }, payload) {
    commit('UPDATE_GOOGLE_ACCOUNT_INFO', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
